import { lazy } from 'react';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

const PdpSharedFramingStatusLazyComponent = lazy(() =>
    import(/* webpackChunkName: "PdpSharedFramingStatus" */ './PdpSharedFramingStatus')
);

export const PdpSharedFramingStatusLazy = props => (
    <ClientSuspense fallback="">
        <PdpSharedFramingStatusLazyComponent {...props} />
    </ClientSuspense>
);
